module.exports = __webpack_public_path__ + "static/media/bicycle-bike-old-svgrepo-com.6a1ecb48.svg";